import React from "react";

function Loader({ loading }) {
  return (
    <div
      hidden={!loading}
      id="global-loader"
      style={{ background: "none", width: "50%", height: "50%" }}
    >
      <div class="whirly-loader"> </div>
    </div>
  );
}

export default Loader;
